<my-content placeholder="headerContent">
    <div class="heroHomeLogoContainer">
        <img class="heroHomeLogo" src="assets/img/{{ clientID }}/herologo.png" />
    </div>
    <div class="homeTitle">{{ 'Home.Title' | translate:pageContentParams }}</div>

    <div *ngIf="environment.emergencyBannerHidden != true" class="homeSubTitle">{{ 'Home.SubTitle' | translate:pageContentParams }}</div>

    <div class="emergencyScheduledContainer" *ngIf="environment.emergencyEnabled == true && environment.emergencyTileEnabled == false">

        <div class="emergencyContainer buttonPointer" (click)="emergencyClicked()">

            <div class="background">
                <div class="topBoxLeft">
                    <div class="topBoxIcon">
                        <img src="assets/img/{{ clientID }}/home/emergency.png"  />
                    </div>
                    <div class="topBoxIconSubtext">{{ 'Home.EmergencyIconText' | translate:pageContentParams }}</div>
                </div>
                <div class="topBoxRight">
                    <div class="topBoxTitle">{{ 'Home.EmergencyTitle' | translate:pageContentParams }}</div>
                    <div class="topBoxDescription">{{ 'Home.EmergencySubTitle' | translate:pageContentParams }}</div>
                    <div class="topBoxButton standardButton buttonPointer">{{ 'Home.BookNowButton' | translate:pageContentParams }}</div>
                </div>
                <div style="clear: both;"></div>
            </div>
        </div>
        <div class="scheduledContainer buttonPointer" (click)="scheduledClicked(servicesAnchor)">
            <div class="topBoxLeft">
                <div class="topBoxIcon">
                    <img src="assets/img/{{ clientID }}/home/scheduled.png"  />
                </div>
                <div class="topBoxIconSubtext">{{ 'Home.ScheduledIconText' | translate:pageContentParams }}</div>
            </div>
            <div class="topBoxRight">
                <div class="topBoxTitle">{{ 'Home.ScheduledTitle' | translate:pageContentParams }}</div>
                <div class="topBoxDescription">{{ 'Home.ScheduledSubTitle' | translate:pageContentParams }}</div>
                <div class="topBoxButton standardButton buttonPointer">{{ 'Home.BookNowButton' | translate:pageContentParams }}</div>
            </div>
            <div style="clear: both;"></div>
        </div>
    </div>

    <div class="sellingPointContainer">
        <div class="sellingPoint">
            <img src="assets/img/{{ clientID }}/home/homestar.png" />
            <br /><span class="sellingPointText">{{ 'Home.SellingPoint1' | translate:pageContentParams }}</span>
        </div>
        <div class="sellingPoint">
            <img src="assets/img/{{ clientID }}/home/hometrade.png" />
            <br /><span class="sellingPointText">{{ 'Home.SellingPoint2' | translate:pageContentParams }}</span>
        </div>
        <div class="sellingPoint">
            <img src="assets/img/{{ clientID }}/home/homeprice.png" />
            <br /><span class="sellingPointText">{{ 'Home.SellingPoint3' | translate:pageContentParams }}</span>
        </div>
    </div>
</my-content>

<my-content placeholder="main">
    <div class="popupBlocker" *ngIf="showSomethingElsePopup"></div>
    <div class="popupContainer" *ngIf="showSomethingElsePopup">
        <div class="popupHeader">
        <div class="popupTitle">{{ 'Home.SomethingElseTitle' | translate:pageContentParams }}</div>
        <div class="popupClose buttonPointer" (click)="toggleSomethingElsePopup(false)">X</div>
        </div>
        <div class="popupBody">
        <div class="popupContent">
            <span [innerHTML]="'Home.SomethingElseBody1' | translate:pageContentParams"></span>
            <br /><br />
            <span [innerHTML]="'Home.SomethingElseBody2' | translate:pageContentParams"></span>
        </div>
        <div class="popupButtons">
            <div class="standardButton buttonPointer" (click)="toggleSomethingElsePopup(false)">{{ 'Master.PopupClose' | translate:pageContentParams }}</div>
        </div>
        </div>
    </div>

    <div class="stepTitle" #servicesAnchor>{{ 'Home.ServicesTitle' | translate:pageContentParams }}</div>
    
    <div class="homeTradesContainer">
        <div class="homeTrade buttonPointer" (click)="emergencyClicked()" *ngIf="environment.emergencyEnabled == true && environment.emergencyTileEnabled == true">
            <img src="assets/img/{{ clientID }}/home/tradetypes/emergency.png" />
            <div class="tradeName">{{ 'Home.EmergencyTitle' | translate:pageContentParams }}</div>
            <div class="standardButton tradeBookButton buttonPointer">{{ 'Home.BookNowButton' | translate:pageContentParams }}</div>
        </div>

        <div *ngFor="let trade of metaData.homePagetradeTypes" class="homeTrade buttonPointer">

            <div *ngIf="showTradeTypeInformationIconForTrade(trade.id)" (click)="showTradeTypeInformationPopup(trade.id)" class="tradeTypeInformationIconContainer">
                <img class="tradeTypeInformationIconImg" src="assets/img/{{ clientID }}/icons/info.png" />
            </div>
            <div (click)="gotoRoute(trade.urlID)">
                <img src="assets/img/{{ clientID }}/home/tradetypes/{{ trade.icon }}" />
                <div class="tradeName" [class.uppercaseLabel]="trade.name == 'HVAC'">{{ trade.name.toUpperCase() }}</div>
                <div class="standardButton tradeBookButton buttonPointer">{{ 'Home.BookNowButton' | translate:pageContentParams }}</div>
            </div>
        </div>

        <div class="homeTrade buttonPointer" (click)="toggleSomethingElsePopup(true)" *ngIf="environment.somethingElseEnabled == true">
            <img src="assets/img/{{ clientID }}/home/tradetypes/somethingelse.png" />
            <div class="tradeName">{{ 'Home.SomethingElseTitle' | translate:pageContentParams }}</div>
            <div class="standardButton tradeBookButton buttonPointer">{{ 'Home.BookNowButton' | translate:pageContentParams }}</div>
        </div>
        
        <!-- CARPET CLEANING (CHEMDRY) -->
        <HomeServices-clickout-link 
        [iconSrc]="'assets/img/3978/home/tradetypes/carpet-cleaning.png'"
        [redirectURL]="'https://www.chemdry.co.nz/aa-home'"
        [tradeName]="'Carpet Cleaning'"
        [pageContentParams]="pageContentParams"
        [showInfo]="true"
        [tradeTypeID]="tradeTypes.CarpetCleaningService"
        [externalRedirectPopupType]="externalRedirectPopupType.RedirectToChemDryService"
        ></HomeServices-clickout-link>

        <!-- MOVING SERVICE (SMART EXPRESS) -->
        <HomeServices-clickout-link 
        [iconSrc]="'assets/img/3978/home/tradetypes/moving-service.png'"
        [redirectURL]="'https://www.smartexpress.co.nz/aa-home/'"
        [tradeName]="'Moving In/Out'"
        [pageContentParams]="pageContentParams"
        [showInfo]="true"
        [tradeTypeID]="tradeTypes.MovingService"
        [externalRedirectPopupType]="externalRedirectPopupType.RedirectToMovingService"
        ></HomeServices-clickout-link>

        <!-- FLATPACK ASSEMBLY-->
        <HomeServices-clickout-link 
        [iconSrc]="'assets/img/3978/home/tradetypes/kitset.png'" 
        [redirectURL]="'https://obp.kitsetassemblyservices.com/s/aa-nz/select-product/?checkoutType=primary'"
        [tradeName]="'Flatpack Assembly'"
        [pageContentParams]="pageContentParams"
        [showInfo]="true"
        [tradeTypeID]="tradeTypes.AAFlatPackAssembly"
        [externalRedirectPopupType]="externalRedirectPopupType.RedirectGeneric"
        ></HomeServices-clickout-link>

        <!-- HRV: VENTILATION -->
        <HomeServices-clickout-link 
        [iconSrc]="'assets/img/3978/home/tradetypes/HRV-ventilation.png'" 
        [redirectURL]="'https://www.hrv.co.nz/ventilation-aa-home'"
        [tradeName]="'HRV Ventilation'"
        [pageContentParams]="pageContentParams"
        [showInfo]="false"
        [externalRedirectPopupType]="externalRedirectPopupType.RedirectToHRV"
        ></HomeServices-clickout-link>

        <!-- HRV: EXTRACTOR FAN -->
        <HomeServices-clickout-link 
        [iconSrc]="'assets/img/3978/home/tradetypes/HRV-extraction-fan.png'" 
        [redirectURL]="'https://www.hrv.co.nz/extraction-fan-aa-home'"
        [tradeName]="'HRV Extractor Fan'"
        [pageContentParams]="pageContentParams"
        [showInfo]="false"
        [externalRedirectPopupType]="externalRedirectPopupType.RedirectToHRV"
        ></HomeServices-clickout-link>

        <!-- HRV: WATER FILTRATION -->
        <HomeServices-clickout-link 
        [iconSrc]="'assets/img/3978/home/tradetypes/HRV-water-filtration.png'" 
        [redirectURL]="'https://www.hrv.co.nz/water-aa-home'"
        [tradeName]="'HRV Water Filtration'"
        [pageContentParams]="pageContentParams"
        [showInfo]="false"
        [externalRedirectPopupType]="externalRedirectPopupType.RedirectToHRV"
        ></HomeServices-clickout-link>

        <!-- HRV: AIR CON / HEAT PUMP -->
        <HomeServices-clickout-link 
        [iconSrc]="'assets/img/3978/home/tradetypes/hvac.png'" 
        [redirectURL]="'https://www.hrv.co.nz/heat-pump-aa-home'"
        [tradeName]="'HRV AIR CON / HEAT PUMP'"
        [pageContentParams]="pageContentParams"
        [showInfo]="false"
        [externalRedirectPopupType]="externalRedirectPopupType.RedirectToHRV"
        ></HomeServices-clickout-link>

    </div>
    
    <div class="homeMessageBar" *ngIf="clientID == clients.AANZ">Please note not all of the above services are currently available in each region. Click on the service you need to check availability in your postcode.</div>

    <div *ngIf="environment.showHowItWorks">
        <div class="stepTitle howItWorksTitle" #servicesAnchor>{{ 'Home.HowItWorks.Title' | translate:pageContentParams }}</div>
        <div class="homepageArea mobile">
            <div class="howItWorksPhoneContainer">
                <img src="assets/img/{{ clientID }}/home/phone.png" />
            </div>

            <div class="howItWorksInfoContainer">

                <div class="howItWorksPoint">
                    <div class="howItWorksIcon">
                        <img src="assets/img/{{ clientID }}/home/tools.png" />
                    </div>
                    <div class="howItWorksRightBox">
                        <div class="howItWorksHeader">{{ 'Home.HowItWorks.Step1Title' | translate:pageContentParams }}</div>
                        <div class="howItWorksText">{{ 'Home.HowItWorks.Step1SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div class="howItWorksPoint">
                    <div class="howItWorksIcon">
                        <img src="assets/img/{{ clientID }}/home/pchome.png" />
                    </div>
                    <div class="howItWorksRightBox">
                        <div class="howItWorksHeader">{{ 'Home.HowItWorks.Step2Title' | translate:pageContentParams }}</div>
                        <div class="howItWorksText">{{ 'Home.HowItWorks.Step2SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div class="howItWorksPoint">
                    <div class="howItWorksIcon">
                        <img src="assets/img/{{ clientID }}/home/tracking.png" />
                    </div>
                    <div class="howItWorksRightBox">
                        <div class="howItWorksHeader">{{ 'Home.HowItWorks.Step3Title' | translate:pageContentParams }}</div>
                        <div class="howItWorksText">{{ 'Home.HowItWorks.Step3SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div style="clear: both;"></div>

            </div>
        </div>

        <div class="stepTitle differentTitle" #servicesAnchor>{{ 'Home.WhyWeAreDifferent.Title' | translate:pageContentParams }}</div>
        <div class="homepageArea">
            <div class="differentContainer">

                <div class="differentPoint marginBottom">
                    <div class="differentIcon">
                        <img src="assets/img/{{ clientID }}/home/time.png" />
                    </div>
                    <div class="differentRightBox">
                        <div class="differentHeader">{{ 'Home.WhyWeAreDifferent.Step1Title' | translate:pageContentParams }}</div>
                        <div class="differentText">{{ 'Home.WhyWeAreDifferent.Step1SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div class="differentPoint marginBottom">
                    <div class="differentIcon">
                        <img src="assets/img/{{ clientID }}/home/value.png" />
                    </div>
                    <div class="differentRightBox">
                        <div class="differentHeader">{{ 'Home.WhyWeAreDifferent.Step2Title' | translate:pageContentParams }}</div>
                        <div class="differentText">{{ 'Home.WhyWeAreDifferent.Step2SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div class="differentPoint marginBottom">
                    <div class="differentIcon">
                        <img src="assets/img/{{ clientID }}/home/customerservice.png" />
                    </div>
                    <div class="differentRightBox">
                        <div class="differentHeader">{{ 'Home.WhyWeAreDifferent.Step3Title' | translate:pageContentParams }}</div>
                        <div class="differentText">{{ 'Home.WhyWeAreDifferent.Step3SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div class="differentPoint marginBottom">
                    <div class="differentIcon">
                        <img src="assets/img/{{ clientID }}/home/certified.png" />
                    </div>
                    <div class="differentRightBox">
                        <div class="differentHeader">{{ 'Home.WhyWeAreDifferent.Step4Title' | translate:pageContentParams }}</div>
                        <div class="differentText">{{ 'Home.WhyWeAreDifferent.Step4SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div class="differentPoint marginBottom">
                    <div class="differentIcon">
                        <img src="assets/img/{{ clientID }}/home/schedule.png" />
                    </div>
                    <div class="differentRightBox">
                        <div class="differentHeader">{{ 'Home.WhyWeAreDifferent.Step5Title' | translate:pageContentParams }}</div>
                        <div class="differentText">{{ 'Home.WhyWeAreDifferent.Step5SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div class="differentPoint marginBottom">
                    <div class="differentIcon">
                        <img src="assets/img/{{ clientID }}/home/24hour.png" />
                    </div>
                    <div class="differentRightBox">
                        <div class="differentHeader">{{ 'Home.WhyWeAreDifferent.Step6Title' | translate:pageContentParams }}</div>
                        <div class="differentText">{{ 'Home.WhyWeAreDifferent.Step6SubTitle' | translate:pageContentParams }}</div>
                    </div>
                    <div style="clear: both;"></div>
                </div>

                <div style="clear: both;"></div>

            </div>
        </div>
    </div>

</my-content>
